import { Button } from "components/Button/Button";

interface CancelButtonProps {
    onClick: () => void;
    label?: string;
    className?: string;
    variation?: "dark";
}

export const CancelButton = ({ onClick, label, className, variation }: CancelButtonProps) => (
    <Button
        variation={variation ?? "white"}
        label={label ?? "Cancel"}
        onClick={onClick}
        className={className ?? ""}
    />
);

export const cancelButtonProps = { className: "button button--white" };
